export default function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}


//////////////////
// WEBPACK FOOTER
// /Users/mac-10/vvv-local/www/cinqfontaines.test/public_html/wp-content/themes/cinqfontaines/node_modules/swiper/core/translate/maxTranslate.js
// module id = 51
// module chunks = 0